export const paths = {

  // common paths for both all
  login: "/",
  user: {
    commonPoint: "/",
    dashboard: "dashboard",
    moDashboard: "mo/dashboard",
    adminDashboard: "admin/dashboard",
    stateDashboard: "state/dashboard",
    adminStatewiseStats: "admin/statewise-stats",
    beneficiaryManagement: "beneficiary-management",
    moBeneficiaryManagement: "mo/beneficiary-management",
    downloadData: 'download-data',
    moDownloadData: 'mo/download-data',
    treatmentModule: "treatment-module",
    appointmentManagement: "mo/appointmentManagement",
    patientRegistration: "patient-registration",
    miTreatmentProcedure: "treatment-procedure-details",
    // temp
    treatmentProcedure: "mo/treatment-procedure",
    treatmentProcedureStep: "mo/treatment-procedure-steps",

    profileView: "view/profile",
    hrManagement: "mo/hr-management",

    adminDownloadData: "admin/download-all-data",
    stateCredDownload: "state/download-credentials",
  },
}

export const apisPath = {
  // common API paths
  login: "/user/login",
  logOut: "/user/logout",
  userProfile: "/user/profile",
  miDashboard: "/mi/dashboard",

  //mi
  patientRegistration: "/patient/register",
  patientList: "/patient/list",
  patientDetails: "/patient",

  // admin and all 
  adminDashboard: "/dashboard/summary",

  // state 
  stateCredentialsDownload: "/user/download-cred-excel",

  // mi multistep
  patientTreatmentStep: "/patient-steps/step",
  getPatientTreatmentStep: "/patient-steps/form",

  //abdm
  encryptAPI: "/encrypt",
  abdmAccessToken: "/abdm/access-token",
  
  // abdm - aadhaar verificaton 
  sendAadhaarOtp: "/abdm/send-aadhaar-otp",
  verifyAadhaarOtp: "/abdm/verify-aadhaar-otp",
  abhaEnrollSuggestions: "/abdm/abha-enroll-suggestion",
  preferredAbhaAddress: "/abdm/preferred-abha-address",
  sendMobileUpdateOtp: "/abdm/send-mobile-update-otp",
  verifyMobileUpdateOtp: "/abdm/verify-mobile-update-otp",
  saveHealthInfo: "/abdm/save-health-id-info",

  // abdm - mobile verificaton 
  searchByMobile: "/abdm/search-by-mobile",
  sendMobileOtp: "/abdm/send-mobile-otp",
  verifyMobileOtp: "/abdm/verify-mobile-otp",
  sendMobileOtpMo: "/abdm/mo-send-mobile-otp",
  verifyMobileOtpMo: "/abdm/mo-verify-mobile-otp",
  verifyAbhaUser: "/abdm/verify-user",

  // abdm - ABHA verificaton 
  sendAbhaOtp: "/abdm/send-abha-otp",
  verifyAbhaOtp: "/abdm/verify-abha-otp",
  verifyAbhaOtpUser: "/abdm/get-profile",

  //abdm - demographic authentication
  userDemographicVerify: "/abdm/user-demo-auth",

  // mo
  moDashboard: "/mo/dashboard",
  moPatientList: "/mo/patient_list",
  bookPatientAppointment: "/mo/slot/book",
  moPatientTreatmentStep: "/mo/patient-steps/step",
  getMoPatientTreatmentStep: "/mo/form",
  createSlots: "/mo/slot/create",
  getAllSlots: "/mo/slot/all",
  getAllChemoSessions: "/mo/patient/manageslot",
  deleteChemoSessions: "/mo/patient/cancel_appointment",

  // HR management 
  getDoctorDetails: "/master/doctor/facility",
  createDoctorDetails: "/master/doctor",
  doctorDetailsMapping: "/master/doctor-mapping",
  doctorDelete:"/master/doctor",
  getDoctorsCardDetails: "/master/facility/doctors_beds",

  // master apis
  masters: {
    stateMaster: "/master/states",
    districtMaster: "/master/districts",
    dccMaster: "/master/dccc",
    medicineMaster: "/master/medicine",
    preMedicationMaster: "/master/premedication",
    preMedicationDrugSearch: "/master/premedication/search"
  },

  // reports
  reports: {
    getReportDataCount: "/report/tccc-and-referred-dccc-count",
    reportsMaster: "/report/tccc-and-dccc-reports-filter",
    downloadNationalReport: "/report/national-facility-count",
    getNationalReportView: "/report/national-facility-count-view",
    getTCCCReport: "/report/tccc-report",
    getDCCCSummaryReport: "/report/state-summary-report",
  }
};